import React, { useState } from 'react'
// import FiveColumnSlider from  '../../slider/five-column-slider'

const HeroFilter = ({ config, filters, updateFilter } ) => {
		
	return (
		<div id="hero-filter" style={{ display: 'none' }}>
			<h2>{config.title}</h2>
			<div className='table-scroll'>
				<div className='hero-filter'>
					{config.tags.map( tag => (
						<Filter tagObj={tag} filters={filters} updateFilter={updateFilter} key={tag.tag} />		
					))}
				</div>
			</div>
		</div>
	)
}

const Filter = ({ tagObj, filters, updateFilter }) => {
	
	let styleObj = "filter"
	if( filters.tag == tagObj.tag ) {
		styleObj = "filter highlight"
	}
	return (
		
			<div className={"age-filter " + tagObj.tag.replace(/\s/g, "")}>
				<div className={styleObj}>
					<div className='filter-bg'>
						<a onClick={(ident,obj) => updateFilter('tag',{ value: tagObj.tag })} ></a>
					</div>
					<p>{tagObj.name}</p>
				</div>
			</div>
		
	)
}

export default HeroFilter
